import { SchedulingType } from '@weave/schema-gen-ts/dist/schemas/ai-settings/v1/ai_settings.pb';

const VALID_SCHEDULING_TYPES = new Set<string>(Object.values(SchedulingType));

/**
 * Normalizes any unrecognized scheduling type string (e.g. 'DO_NOT_HELP')
 * to the canonical SchedulingType.NONE enum value.
 */
export const normalizeSchedulingType = (value?: string): SchedulingType =>
  value && VALID_SCHEDULING_TYPES.has(value) ? (value as SchedulingType) : SchedulingType.NONE;
